import { Component, Prop, h } from '@stencil/core';

/**
 * This component is used to display the hours of operation for a location.
 */
@Component({
  tag: 'fccd-open-hours',
  styleUrl: 'fccd-open-hours.scss',
})
export class OpenHours {
  /**
   * The hours of operation for the location.
   */
  @Prop()
  hoursText: string = '';

  @Prop()
  textSize: 'sm' | 'xs' = 'xs';

  /**
   * Check if the hoursText contains the substring.
   * @param substring  The substring to search for in the hoursText.
   * @returns True if the hoursText contains the substring, false otherwise.
   */
  private containsSubstring(substring: string) {
    const index = this.hoursText?.toLowerCase()?.indexOf(substring);
    return index !== undefined && index !== -1;
  }

  render() {
    const { hoursText, textSize } = this;
    return (
      <hp5-semantic size-selection={textSize}>
        {this.containsSubstring('open until') ? (
          <p class="no-margin-top-bottom">
            <span class="location-open">Open</span>
            {hoursText.split('Open').pop()}
          </p>
        ) : this.containsSubstring('open for walk-in care until') ? (
          <p class="no-margin-top-bottom">
            <span class="location-open">Open for walk-in care</span>
            {hoursText.split('Open for walk-in care').pop()}
          </p>
        ) : this.containsSubstring('closed. reopens') ? (
          <p class="no-margin-top-bottom">
            <span class="location-closed">Closed</span>
            {hoursText.split('Closed').pop()}
          </p>
        ) : this.containsSubstring('temporarily') ? (
          <p class="no-margin-top-bottom">
            <b class="location-tempclosed">{hoursText}</b>
          </p>
        ) : this.containsSubstring('video') ? (
          <p class="no-margin-top-bottom">
            <b class="location-closed">{hoursText}</b>
          </p>
        ) : (
          <span>{hoursText}</span>
        )}
      </hp5-semantic>
    );
  }
}
